{
    "name": "cache-cmd",
    "version": "0.4.0",
    "description": "Run and cache a command based on various factors",
    "keywords": [
        "cache",
        "debounce",
        "cli",
        "conditional",
        "run",
        "cmd",
        "command",
        "time",
        "hash"
    ],
    "homepage": "https://github.com/dcastil/cache-cmd",
    "bugs": {
        "url": "https://github.com/dcastil/cache-cmd/issues"
    },
    "funding": {
        "type": "github",
        "url": "https://github.com/sponsors/dcastil"
    },
    "license": "MIT",
    "author": "Dany Castillo",
    "files": [
        "dist",
        "src"
    ],
    "bin": "dist/cli.js",
    "type": "module",
    "source": "src/cli.ts",
    "repository": {
        "type": "git",
        "url": "https://github.com/dcastil/cache-cmd.git"
    },
    "scripts": {
        "cache-cmd": "node ./dist/cli.js",
        "build": "rm -rf dist/* && esbuild src/cli.ts --bundle --platform=node --target=node20 --packages=external --format=esm --sourcemap --outfile=dist/cli.js",
        "type-check": "tsc --build",
        "preversion": "if [ -n \"$DANYS_MACHINE\" ]; then git checkout main && git pull; fi",
        "postversion": "if [ -n \"$DANYS_MACHINE\" ]; then git push --follow-tags && open https://github.com/dcastil/cache-cmd/releases; fi"
    },
    "dependencies": {
        "date-fns": "^4.1.0",
        "del": "^8.0.0",
        "exec-sh": "^0.4.0",
        "find-cache-dir": "^5.0.0",
        "flat-cache": "^6.1.3",
        "hard-rejection": "^2.1.0",
        "hasha": "^6.0.0",
        "lodash-es": "^4.17.21",
        "sade": "^1.8.1"
    },
    "devDependencies": {
        "@types/find-cache-dir": "^5.0.2",
        "@types/flat-cache": "^2.0.2",
        "@types/lodash-es": "^4.17.12",
        "@types/node": "^22.10.1",
        "@types/sade": "^1.8.0",
        "esbuild": "^0.24.0",
        "prettier": "^3.4.2",
        "typescript": "^5.7.2"
    },
    "publishConfig": {
        "provenance": true
    }
}
